// extracted by mini-css-extract-plugin
export default {"tupacGrid":"kn-z","tupacHeader":"ln-z","tupacHeader2":"mn-z","tupacMenu":"nn-z","tupacMenu2":"on-z","tupacMain":"pn-z","tupacMain2":"qn-z"};